<template>
  <div>
    <div class="container-fluid">
      <div class="form-container">
        <form
          method="POST"
          class="form py-4 col-lg-4 col-md-7 col-sm-9 col-11 mx-auto"
        >
          <h4 class="text-center my-3 form-heading">Recover your password</h4>

          <p
            class="errors mb-4 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="error"
            v-show="errors"
          ></p>
          <p
            class="success mb-4 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="success"
            v-show="success"
          ></p>
          <div class="form-group col-lg-10 mx-auto col-md-10 col-11 col-sm-10">
            <label class="form-labe" for="phoneCodes">Phone number</label>
            <br />
            <span class="f-small"
              >*First select the country phone code then fill the remaining
              numbers in the phone number box*</span
            >

            <select
              class="form-control"
              v-model="data.selector"
              @change="getCode()"
              name="phoneCodes"
              id="phoneCodes"
              required
            >
              <option
                v-for="phoneCode in phoneCodes"
                v-bind:value="phoneCode.code"
                :key="phoneCode.code"
              >
                {{ phoneCode.code }} --
                {{ phoneCode.name }}
              </option>
            </select>
          </div>

          <div
            class="input-group  col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
          >
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{
                currentCode
              }}</span>
            </div>

            <input
              type="number"
              class="form-control mt-0"
              placeholder="Phone number"
              name="phone"
              id="phone"
              v-model="data.phone"
              aria-describedby="basic-addon1"
              required
            />
          </div>

          <div class="text-center my-4">
            <button
              type="submit"
              class="btn btn_styles btn-md btn-primary"
              @click.prevent="sendCode"
            >
              Send Code
              <span
                v-if="hasSubmitted"
                class="spinner-border spinner-border-sm ml-2 my-auto"
              ></span>
            </button>
          </div>
          <div class="mx-auto mb-4 back-to-login col-lg-10">
            <span class="text-center">Remembered password?</span>
            <a @click="login()" class="ml-2 text-center back-link"
              >Go back to login</a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
const url = "https://bookinga.herokuapp.com/api/v1/client/forgotpassword";
import phoneCodes from "./phoneCodes.json";
import axios from "axios";
import router from "../../router/index.ts";
export default {
  data() {
    return {
      currentCode: "+250",
      errors: false,
      hasSubmitted: false,
      success: false,
      UserCountryName: "",
      phoneCodes: phoneCodes.countries,
      data: { phone: "", selector: "+250" },
    };
  },
  methods: {
    getCode() {
      this.currentCode = this.data.selector;
    },
    login() {
      router.push("/login");
    },
    sendCode: function() {
      if (this.data.phone.length < 1) {
        this.errors = true;
        document.getElementById("error").innerHTML =
          "Please! Enter your account phone number";
      } else {
        this.hasSubmitted = true;
        axios
          .post(url, {
            Telephone: this.currentCode + this.data.phone,
          })
          .then((response) => {
            if (response.data.success == true) {
              this.hasSubmitted = false;
              var encryptedAES = CryptoJS.AES.encrypt(
                this.currentCode + this.data.phone,
                "UserWithiNoUrYuhfdnfhdsfshfsfdshgfsyrsbfdfsdsfdfdfdf909fdsfjfjsfjs"
              );
              return router.push("/resetByPhone/?txyz04eg=" + encryptedAES);
            } else {
              this.hasSubmitted = false;
              this.errors = true;
              document.getElementById("error").innerHTML =
                response.data.message;
            }
          })
          .catch((error) => {
            this.hasSubmitted = false;
            this.errors = true;
            document.getElementById("error").innerHTML = error.response.data;
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.back-to-login {
  font-size: 15px !important;
}
.back-link {
  color: rgb(25, 83, 243) !important;
}
</style>
